import { render, staticRenderFns } from "./KardexPagos.vue?vue&type=template&id=c4947d58"
import script from "./KardexPagos.vue?vue&type=script&lang=js"
export * from "./KardexPagos.vue?vue&type=script&lang=js"
import style0 from "./KardexPagos.vue?vue&type=style&index=0&id=c4947d58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports